import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { v4 as uuid } from 'uuid';

import { DropdownType } from './dropdown.enum';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdButtonComponent } from '../../buttons/button/button.component';
import { SdButtonIconComponent } from '../../buttons/button-icon/button-icon.component';
import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { SdThemeWrapperComponent } from '../../theme-wrapper/theme-wrapper.component';
import { ModalType } from '../../modals/modal/modal.enum';
import { SdModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'sd-dropdown',
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdModalComponent,
    SdButtonComponent,
    NgClass,
    SdButtonIconComponent,
    SdThemeWrapperComponent
  ]
})
export class SdDropdownComponent extends SdThemeComponent {
  /**
   * Defines the type of button to be displayed
   */
  @Input()
  isBtnSmall = false;

  @Input()
  isAutocomplete = false;

  /**
   * Sets the class to be passed to the dropdown open in the cdkoverlay
   */
  @Input()
  dropdownCustomClass = '';

  /**
   * Sets the id to be passed to the open dropdown in the cdkoverlay
   */
  @Input()
  dropdownCustomId = '';

  @Input()
  isSelected = false;

  @Input()
  disabled = false;

  @Input()
  readonly = false;

  @Input()
  isOpened = false;

  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  @Output()
  buttonSize = new EventEmitter<number>();

  @Input()
  icon: string;

  @Input()
  iconSize: IconSizeEnum = IconSizeEnum.small;

  @Input()
  isCustomDropdown = false;

  @Input()
  clickToOpen = true;

  @Input()
  buttonIconTitle: string;

  @Input()
  buttonIconTitleHidden: boolean;

  @Input()
  iconLabel: string;

  @Input()
  labeledBy: string;

  @Input()
  focus = true;

  @Input()
  set type(type: DropdownType) {
    if (!type) {
      throw new Error(
        `Le type que vous passez est ${type} pensez à utilisez [type]="'select'" \n
        voir les types ${JSON.stringify(Object.keys(DropdownType))}`,
      );
    }
    this._type = type;
  }

  get type() {
    return this._type;
  }

  @Input() class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.icon ? 'c--inline' : '',
      this.isCustomDropdown ? 'is-custom' : '',
      this.isSelected ? 'is-selected' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  @ViewChild(CdkConnectedOverlay)
  cdkConnectedOverlay: CdkConnectedOverlay;

  @ViewChild('modal')
  modal: SdModalComponent;

  positionEnum = PositionEnum;
  _type: DropdownType = DropdownType.dropdown;
  uuidButton: string = 'buttonSelect-' + uuid();
  modalType = ModalType.dropdown;

  notifyButtonSizeOnClick($event: MouseEvent) {
    this.buttonSize.emit(($event.target as HTMLElement).clientWidth);
  }

  /**
   * Allow to update modal position
   */
  updatePosition() {
    this.modal.updatePosition();
  }
}
